import { Controller } from "@hotwired/stimulus"

// Simple inline edit for conversation subject
export default class extends Controller {
  static targets = ["display", "form", "input", "text"]
  static values = { url: String }

  edit() {
    this.displayTarget.classList.add("d-none")
    this.formTarget.classList.remove("d-none")
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel() {
    this.formTarget.classList.add("d-none")
    this.displayTarget.classList.remove("d-none")
    // Reset input to current displayed value
    const currentText = this.textTarget.textContent.trim()
    this.inputTarget.value = currentText === "No Subject" ? "" : currentText
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.cancel()
    } else if (event.key === "Enter") {
      event.preventDefault()
      this.save()
    }
  }

  async save() {
    const newValue = this.inputTarget.value.trim()
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      const response = await fetch(this.urlValue, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify({ conversation: { subject: newValue } })
      })

      if (response.ok) {
        // Update the display text first
        this.textTarget.textContent = newValue || "No Subject"
        // Then hide the form and show display
        this.formTarget.classList.add("d-none")
        this.displayTarget.classList.remove("d-none")
      } else {
        console.error('Failed to save subject')
      }
    } catch (error) {
      console.error('Error saving subject:', error)
    }
  }
}
